import { View } from '@gluestack-ui/themed'
import React, { FunctionComponent, PropsWithChildren } from 'react'
import { ImageBackground, ImageBackgroundProps, ImageProps, ImageStyle, StyleProp } from 'react-native'

interface FastImageBackgroundProps extends PropsWithChildren<Omit<ImageProps, 'source'>> {
  source?: ImageProps['source']
  style?: StyleProp<ImageStyle>
  imageStyle?: ImageStyle
}

export const FastImageBackground: FunctionComponent<FastImageBackgroundProps> = props => {
  const { children, style, imageStyle, source, resizeMode } = props
  return (
    <View style={style}>
      <ImageBackground
        source={source as ImageBackgroundProps}
        // eslint-disable-next-line react-native/no-inline-styles
        style={[{ flex: 1 }, imageStyle]}
        resizeMode={resizeMode}
      >
        {children}
      </ImageBackground>
    </View>
  )
}
